import React from "react";

const RoleSelector = ({ roles = [], selectedRoleId, onChange }) => {
  return (
    <div className="mb-6">
      <label className="block mb-2 font-semibold text-green-700">
        Pilih Role:
      </label>
      <select
        value={selectedRoleId || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 py-2 text-green-800 border border-green-300 rounded-md focus:ring-2 focus:ring-green-500"
      >
        <option value="">-- Pilih Role --</option>
        {roles.map((role) => (
          <option key={role.id} value={role.id}>
            {role.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RoleSelector;
